import React from 'react';

import './AuPageAlert.scss';

interface Props {
  as: 'info' | 'warning' | 'error' | 'success';
  title: string;
  message?: string | React.ReactNode;
  className?: string;
  alt?: boolean;
  dark?: boolean;
  inline?: boolean;
  htmlFor: string;
  style?: React.CSSProperties;
}

const options = {
  info: 'au-page-alerts--info',
  warning: 'au-page-alerts--warning',
  error: 'au-page-alerts--error',
  success: 'au-page-alerts--success',
};

/**
 * DEFAULT
 * Page alert
 *
 */
const AuPageAlert: React.FC<Props> = ({ as, title, message, alt, dark, className = '' }) => (
  <div
    className={
      `au-body au-page-alerts ${className}` +
      `${dark ? ' au-page-alerts--dark au-body--dark' : ''}` +
      `${alt ? ' au-page-alerts--alt au-body--alt' : ''}` +
      ` ${options[as]}`}>
    <h3>{title}</h3>
    {
      message && <p>{message}</p>
    }
  </div>
);

export default AuPageAlert;
